import { QueryClient } from '@tanstack/react-query'
import { INotificationContentHandler } from '@/lib/handler/notification-content-handler'
import { NotificationType } from '@/types/notification'

/**
 * Products Excel Export Content Handler
 * Updates cache when a product export job is completed
 */
export default class ProductsExcelExportContentHandler implements INotificationContentHandler {
  async handle(notification: NotificationType, queryClient: QueryClient): Promise<void> {
    const { payload } = notification

    if (!payload || !payload.id) {
      return
    }

    const exportId = payload.id
    const status = payload.status
    const total = payload.total
    const message = payload.message
    const file = payload.file

    const listQueries = queryClient.getQueriesData({ queryKey: ['productExcelExports'] })

    listQueries.forEach(([queryKey, oldData]: [any, any]) => {
      if (!oldData || !oldData.items) {
        return
      }

      const itemExists = oldData.items.some((item: any) => item.id === exportId)

      if (itemExists) {
        queryClient.setQueryData(queryKey, {
          ...oldData,
          items: oldData.items.map((item: any) =>
            item.id === exportId
              ? {
                  ...item,
                  status,
                  file,
                  total,
                  message,
                  updatedAt: payload.updatedAt
                }
              : item
          )
        })
      }
    })

    const detailQueries = queryClient.getQueriesData({ queryKey: ['productExcelExport', exportId] })

    detailQueries.forEach(([queryKey, oldData]: [any, any]) => {
      if (!oldData) {
        return
      }

      queryClient.setQueryData(queryKey, {
        ...oldData,
        status,
        total,
        file,
        updatedAt: payload.updatedAt
      })
    })

    await queryClient.invalidateQueries({
      queryKey: ['productExcelExports'],
      refetchType: 'none'
    })

    await queryClient.invalidateQueries({
      queryKey: ['productExcelExport', exportId],
      refetchType: 'none'
    })
  }
}
